var render = function render(){var _vm=this,_c=_vm._self._c;return _c('show-admins',{ref:"registerAdmin",attrs:{"is-me":false,"is-deps":true,"title":'Εμφάνιση Διαχειριστών ΔΕΠΣ'}})
}
var staticRenderFns = []

export { render, staticRenderFns }